<template>
    <div class="piscreen">
        <!-- <div class="lock" v-if="locked">
            <div class="fancyBorder">
                <p><span v-for="letter in phrase1" @click="addLetter(letter)">{{ letter }}</span></p>
                <p><span v-for="letter in phrase2" @click="addLetter(letter)">{{ letter }}</span>&nbsp;<span @click="resetLetters">:(</span></p>
                <div class="home">
                    <a href="/"><font-awesome-icon icon="home" /></a>
                </div>
            </div>
            
        </div> -->

        <StatusMessage v-if="statusMessage" :message="statusMessage" category="" :redirect="false" @dismiss="dismissStatusMessage"></StatusMessage>

        <div class="topBar">
            <div class="home">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
            <div class="toggleEnabled" v-if="category == 'players' && selectedPlayer.id" @click="toggleEnabled()">
                <p v-if="selectedPlayer.enabled == 1">Disable</p>
                <p v-if="selectedPlayer.enabled == 0">Enable</p>
            </div>
            <div class="toggleEnabled" v-if="category == 'seasons' && selectedSeason.active == '0'" @click="setActiveSeason()">
                <p>Set as active season</p>
            </div>
        </div>


        <Keyboard v-if="!adminPanelUnlocked" @submitInput="submitAdminPassword" :numericOnly="true" :inputMasked="true"></Keyboard>


        <div class="passwordProtected" v-if="adminPanelUnlocked">

            <nav>
                <ul>
                    <li @click="category = 'players'" v-bind:class="{ active: category == 'players' }">Players</li>
                    <li @click="category = 'seasons'" v-bind:class="{ active: category == 'seasons' }">Seasons</li>
                </ul>
            </nav>

            <div class="players" v-if="category == 'players'">
                <div class="player" v-for="player in players" v-bind:class="{ highlighted: player.id == selectedPlayer.id, disabled: player.enabled == 0 }" @click="selectedPlayer = player">{{ player.name }}</div>
            </div>

            <div class="seasons" v-if="category == 'seasons' && !creatingSeason">
                <div class="season" v-for="season in seasons" v-bind:class="{ active: season.active == '1', highlighted: season.id == selectedSeason.id }" @click="selectedSeason = season">{{ season.name }}</div>
            </div>

            <div class="seasons" v-if="category == 'seasons' && !creatingSeason">
                <div class="season newSeason" @click="creatingSeason=true">+</div>
            </div>        

            <div class="seasons" v-if="category == 'seasons' && !creatingSeason">
                <div class="season danger" @click="assignAllToActiveSeason()">Assign all seasonless points to the active season<br>(activate old season before pressing this)</div>
            </div>

            <div class="seasons" v-if="category == 'seasons' && !creatingSeason">
                <div class="season danger" @click="db_upgrade_01_add_seasons()">Upgrade DB: Add seasons<br>(Back up your DB first!)</div>
            </div>

            <Keyboard v-if="creatingSeason" @submitInput="createSeason" :numericOnly="false"></Keyboard>
        </div>
            
        <!-- <p>{{route}}</p> -->
    </div>

</template>

<script>

import axios from 'axios'
import StatusMessage from './partials/StatusMessage'
import Keyboard from './partials/Keyboard'


export default {

    name: 'AdminArea',

    components: {
        StatusMessage: StatusMessage,
        Keyboard: Keyboard
    },

    data() {
        return {
            category: 'players',
            seasons: [],
            activeSeasonId: 0,
            // route: '',
            statusMessage: '',
            players: [],
            selectedPlayer: {},
            selectedSeason: {},
            
            passphrase: "",
            reloadCheck: 0,
            creatingSeason: false,
            adminPanelUnlocked: false
        }
        
    },

    computed: {
        locked() {
            if (this.passphrase == "frank") {
                return false;
            }
            return true;
        }
    },

    methods: {
        dismissStatusMessage() {
            this.statusMessage = '';
            this.loadUsers();
        },

        resetLetters() {
            this.passphrase = "";
        },

        addLetter(letter) {
            this.passphrase += letter;
        },

        loadUsers() {
            this.players = [];
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/users/get_all_users.php', params).then(function (response) {
                console.log(response);
                // self.statusMessage = response;
                for (let i = 0; i < response.data.length; i++) {
                    let player = {
                        id: response.data[i].id,
                        name: response.data[i].name,
                        enabled: response.data[i].enabled
                    }
                    self.players.push(player);
                }

            }).catch(function (error) {
                console.log(error);
            });
        },

        toggleEnabled() {
            let newState = '0';
            if (this.selectedPlayer.enabled == 0) {
                newState = '1'
            }
            

            const params = new URLSearchParams();
            params.append('user_id', this.selectedPlayer.id);
            params.append('enabled', newState);

            let self = this;

            axios.post('/darts_db/users/update_user.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
                self.selectedPlayer = {};
                // self.loadUsers();
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        db_upgrade_01_add_seasons() {
            const params = new URLSearchParams();

            let self = this;

            axios.post('/darts_db/database/db_upgrade_01_add_seasons.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getAllSeasons() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/seasons/get_all_seasons.php', params).then(function (response) {
                console.log(response);
                self.seasons = response.data;
                for (let i = 0; i < self.seasons.length; i++) {
                    if (self.seasons[i].active == '1') {
                        self.activeSeasonId = self.seasons[i].id
                    }
                }
                self.selectedSeason = {};
                
            }).catch(function (error) {
                console.log(error);
            });
        },

        setActiveSeason() {
            // deactivate current season:
            if (this.activeSeasonId > 0) {
                const params = new URLSearchParams();
                params.append('season_id', this.activeSeasonId);

                let self = this;

                axios.post('/darts_db/seasons/deactivate_season.php', params).then(function (response) {
                    self.reloadSeasons();
                    console.log(response);
                    self.statusMessage = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                    self.statusMessage = error.data;;
                });
            } else {
                this.reloadSeasons();
            }

            // activate season
            const params = new URLSearchParams();
            params.append('season_id', this.selectedSeason.id);

            let self = this;

            axios.post('/darts_db/seasons/activate_season.php', params).then(function (response) {
                self.reloadSeasons();
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        reloadSeasons() {
            this.reloadCheck++;
            if (this.reloadCheck == 2) {
                this.getAllSeasons();
                this.reloadCheck = 0;
            }
        },

        assignAllToActiveSeason() {
            if (confirm("This action cannot be undone. Are you sure?")) {
                const params = new URLSearchParams();
                params.append('season_id', this.activeSeasonId);

                let self = this;

                axios.post('/darts_db/seasons/assign_all_to_active_season.php', params).then(function (response) {
                    console.log(response);
                    self.statusMessage = response.data;
                }).catch(function (error) {
                    console.log(error.response);
                    self.statusMessage = error.data;;
                });
            }
        },

        createSeason(name) {
            this.creatingSeason = false;

            const params = new URLSearchParams();
            params.append('name', name);

            let self = this;

            axios.post('/darts_db/seasons/create_season.php', params).then(function (response) {
                console.log(response);
                self.getAllSeasons();
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
            
        },

        submitAdminPassword(password) {
            if (password == 940477) {
                this.adminPanelUnlocked = true;
            }
        }



    },

    


    mounted() {
        this.loadUsers();
        this.getAllSeasons();
        // this.route = this.$root.currentRoute;
        
    }
}
</script>


<style scoped>

    @font-face {
        font-family: SegoeUI;
        src: url("../../Segoe UI.ttf");
    }

    * {
        font-family: "SegoeUI";
        box-sizing: border-box;
    }
    
    html {
        overflow-x: hidden;
        margin: 0;
        padding: 0;
    }

    body {
        margin: 0;
        background: #444;
        color: #000;
        font-family: "SegoeUI";
        /*overflow-x: hidden;*/
        
        padding: 0;

    }

    .piscreen {
        width: 800px;
        background: #eee;
        min-height: 480px;
    }

    .lock {
        position: absolute;
        width: 800px;
        height: 480px;
        background: #eee;
        z-index: 100;
        padding: 10px;
    }

    .fancyBorder {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 60px;
        text-transform: uppercase;
        flex-direction: column;
        height: 460px;

        /*border: 1px solid #ddd;*/
        background: #eee;
        letter-spacing: 2px;
    }

    .fancyBorder p {
        margin: 15px;
        text-align: center;

    }

    .fancyBorder p:nth-child(2) {
        margin-bottom: 30px;

    }


    .topBar {
        background: #ddd;
        /*padding: 20px;*/
        justify-content: space-between;
        display: flex;
        border-bottom: 1px solid #aaa;
    }

    .players,
    .seasons {
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
    }

    .player,
    .season {
        padding: 10px;
        border: 1px solid black;
        border-radius: 10px;
        margin: 10px;
        background: white;
        height: 48px;
        width: 175px;
        overflow: hidden;
    }

    .season.newSeason {
        width: 50px;
        text-align: center;
        font-size: 2em;
        font-weight: bold;
        line-height: 20px;
        margin-top: 40px;
    }

    .player.disabled {
        background: #ccc;
    }

    .player.highlighted,
    .season.highlighted {
        border: 3px solid red;
    }

    .seasons .season.active {
        background: darkseagreen;
    }

    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #bbb;
        margin: 15px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #fff;
        border-radius: 3px;
        /*height: 60px;*/
        /*left: 0px;*/
        /*top: 0px;*/
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #000;
    }

    .toggleEnabled {
        font-size: 32px;
        border: 1px solid #bbb;
        margin: 15px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        background: #fff;
        border-radius: 3px;
        cursor: pointer;
        user-select: none;
    }

    .toggleEnabled p {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #000;
        margin: 0;
        /*text-transform: uppercase;*/
    }

    nav ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
        border-bottom: 1px solid #aaa;
    }

    nav ul li {
        display: inline-block;
        padding: 20px 40px;
        background: #ddd;
        border-right: 1px solid #aaa;
        font-weight: bold;
    }

    nav ul li.active {
        background: darkseagreen;
    }

    .season.danger {
        width: auto;
        margin-top: 50px;
        color: red;
        font-weight: bold;
        cursor: pointer;
        border: 1px solid red;
        text-align: center;
        height: auto;
        box-shadow: 2px 2px 3px rgba(255,0,0,0.5);
    }


</style>
